import styled from "styled-components";
import { ReactComponent as IconCrossRound } from "../Images/icon_cross_round.svg";
import LayoutModal from "../Layout/LayoutModal";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";

const TabTitleExBox = ({ image, handleClickX }) => {
  return (
    <ModalBox>
      <div className="hrz-wrapper center">
        <p className="bold-text" style={{ fontSize: "24px" }}>
          이벤트 대회 타이틀 예시
        </p>
      </div>
      <div className="hrz-wrapper" style={{ marginTop: "-32px" }}>
        <div style={{ marginLeft: "auto", cursor: "pointer" }}>
          <IconCrossRound onClick={handleClickX} />
        </div>
      </div>

      <p style={{ color: "#888888", marginTop: "20px" }}>
        ‘기본’ 선택 시 탭 타이틀이 ‘이벤트전’ 으로 노출됩니다.
        <br />
        ‘직접입력’ 시 대회 입력한 이름으로 타이틀이 변경됩니다.
      </p>

      <img src={image} style={{ marginTop: "16px" }} />
    </ModalBox>
  );
};

const TabTitleEx = ({ image, handleClickX }) => {
  return (
    <LayoutModal
      Modal={<TabTitleExBox image={image} handleClickX={handleClickX} />}
    />
  );
};

const ModalBox = styled.div`
  width: 537px;
  height: auto;
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);

  // margin-left: 662px;
  // margin-top: 122.75px;
`;

export default TabTitleEx;
